module.exports = __webpack_public_path__ + "static/media/22.6e4c0cb1.jpeg";